import script from "./BlackFridayBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlackFridayBanner.vue?vue&type=script&setup=true&lang=ts"

import "./BlackFridayBanner.vue?vue&type=style&index=0&id=78ea1036&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ea1036"]])

export default __exports__